// import { useDonation } from '../../context/DonationContext';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import secureAnimation from '../../assets/lottie/secure.json'; // Asegúrate de tener esta animación

export default function PaymentInfo() {
    // const { donation } = useDonation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Animaciones para los botones
    const buttonVariants = {
        hover: { scale: 1.02, boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" },
        tap: { scale: 0.98 }
    };

    return (
        <div className="max-w-md mx-auto p-6">
            {/* Encabezado con animación */}
            <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">Método de pago</h2>
                <p className="text-gray-600">Selecciona cómo deseas realizar tu donación</p>
            </div>

            {/* Opciones de pago */}
            <div className="space-y-6 mb-8">
                <motion.div
                    variants={buttonVariants}
                    whileHover="hover"
                    whileTap="tap"
                >
                    <Link
                        to="/pago/tarjeta"
                        className="flex items-center p-6 bg-white border-2 border-gray-100 rounded-xl hover:border-blue-300 transition-all"
                    >
                        <div className="bg-blue-50 p-3 rounded-lg mr-4">
                            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                            </svg>
                        </div>
                        <div className="flex-1">
                            <h3 className="font-semibold text-lg text-gray-800">Tarjeta de crédito/débito</h3>
                            <p className="text-sm text-gray-500">Visa, Mastercard, Amex y más</p>
                        </div>
                        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </Link>
                </motion.div>

                {/* <motion.div
                    variants={buttonVariants}
                    whileHover="hover"
                    whileTap="tap"
                >
                    <Link
                        to="/pago/paypal"
                        className="flex items-center p-6 bg-white border-2 border-gray-100 rounded-xl hover:border-blue-300 transition-all"
                    >
                        <div className="bg-blue-50 p-3 rounded-lg mr-4">
                            <svg className="w-8 h-8 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M7.3 17.3h3.85v-8.6H7.3c-1.3 0-2.45.1-2.45 1.4v5.8c0 1.3 1.15 1.4 2.45 1.4z" fill="#253B80" />
                                <path d="M17.55 8.7h-6.4v8.6h6.4c1.3 0 2.45-.1 2.45-1.4v-5.8c0-1.3-1.15-1.4-2.45-1.4z" fill="#179BD7" />
                                <path d="M11.25 8.7H7.3c-1.3 0-2.45.1-2.45 1.4v5.8c0 1.3 1.15 1.4 2.45 1.4h3.85V8.7z" fill="#222D65" />
                                <path d="M17.55 8.7h-6.4v8.6h6.4c1.3 0 2.45-.1 2.45-1.4v-5.8c0-1.3-1.15-1.4-2.45-1.4z" fill="#253B80" />
                            </svg>
                        </div>
                        <div className="flex-1">
                            <h3 className="font-semibold text-lg text-gray-800">PayPal</h3>
                            <p className="text-sm text-gray-500">Paga con tu cuenta PayPal</p>
                        </div>
                        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </Link>
                </motion.div> */}
            </div>

            {/* Nota de seguridad */}
            <div className="flex items-start bg-blue-50 p-4 rounded-lg">
                {/* <svg className="w-5 h-5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg> */}
                <div className="text-center mb-8">
                    <div className="w-14 h-14 mx-auto mr-4">
                        <Lottie
                            animationData={secureAnimation}
                            loop={true}
                            autoplay={true}
                        />
                    </div>
                </div>
                <p className="text-sm text-blue-800">
                    <span className="font-semibold">Tu seguridad es importante:</span> Todos los datos de pago se procesan con encriptación y nunca se almacenan en nuestros servidores.
                </p>
            </div>
        </div>
    );
}